"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnowCover = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const constants_1 = require("../../constants");
class SnowCover {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.SNOW_COVER;
        this.description = 'Decrease temperature 2 steps. Draw 1 card per influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.KELVINISTS;
    }
    resolve(game, turmoil) {
        const canDecreaseTemperature = game.getTemperature() !== constants_1.MAX_TEMPERATURE;
        if (canDecreaseTemperature)
            game.increaseTemperature(game.getPlayers()[0], -2);
        game.getPlayers().forEach((player) => {
            player.drawCard(turmoil.getPlayerInfluence(player));
        });
    }
}
exports.SnowCover = SnowCover;
//# sourceMappingURL=SnowCover.js.map